<template>
  <section>
    <div class="col1">
      <h3 class="title">Users</h3>


      <pre v-for="user in users" v-bind:key="user.id" style="margin:20px">        
        <router-link v-bind:to="`/entitat/${user.id}`">
          {{ user }}
        </router-link>
      </pre>

    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {  
  data () {
    return {
      users: []
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  mounted () {
    fb.usersCollection.get().then(docs => {
      docs.forEach(doc => {
        let user = doc.data()
        user.id = doc.id
        this.users.push(user)
      })

    });
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Users.vue